import './App.css';
import React from 'react';
import { BrowserRouter, Routes, Route, HashRouter } from 'react-router-dom';
import DashboardLayout from './Shade/Layouts/App';
import Loader from './Shade/Loader/Loader';


const Login = React.lazy(()=>import("./Pages/OnBoardingScreens/Loginscreen/Login"))
const SignUp = React.lazy(()=>import("./Pages/OnBoardingScreens/SignUpScreen/SignUp"))
const OTPVerifIcation = React.lazy(()=>import("./Pages/OnBoardingScreens/OTPVerficationScreen/OTPVerfication"))

// Sales Head Screens
const Analytics = React.lazy(()=>import('./Pages/DashboardScreens/SalesHead/Analytics/Analytics'));
const Sales = React.lazy(()=>import("./Pages/DashboardScreens/SalesHead/Sales/Sales"));
const SInventory = React.lazy(()=>import("./Pages/DashboardScreens/SalesHead/SInventory/SInventory"))
const Scheme = React.lazy(()=>import("./Pages/DashboardScreens/SalesHead/Scheme/Scheme"))
const Conversations = React.lazy(()=>import("./Pages/DashboardScreens/SalesHead/Analytics/conversations"))

// Clinical Head 
const MyDashboard =React.lazy(()=>import("./Pages/DashboardScreens/ClinicalTeam/CDashboard/MyDashboard"))

// Marketing Head
const MarketingAnalytics = React.lazy(()=>import("./Pages/DashboardScreens/MarketingHead/MAnalytics/MarketingAnalytics"))
const KPIManagement = React.lazy(()=>import("./Pages/DashboardScreens/MarketingHead/KPIS/KPIManagement"))
const Event = React.lazy(()=>import("./Pages/DashboardScreens/MarketingHead/Events/Event"))

// Finance Head 
const FAnalytics = React.lazy(()=>import("./Pages/DashboardScreens/FinanceHead/FAnalyatics/FAnalytics"))
const FinanceManagement = React.lazy(()=>import("./Pages/DashboardScreens/FinanceHead/FSales/FinanceManagement"))
const InventoryManagement = React.lazy(()=>import("./Pages/DashboardScreens/FinanceHead/FInventory/InventoryManagement"));
const PurchaseOrder = React.lazy(()=>import("./Pages/DashboardScreens/FinanceHead/PurchaseOrder/PurchaseOrder"));

// Common Screens 
const HelpSupport = React.lazy(()=>import("./Pages/DashboardScreens/HelpSupport/HelpSupport"))

const Profile = React.lazy(()=>import("./Pages/DashboardScreens/SalesHead/profile/profile"))
const MProfile = React.lazy(()=>import("./Pages/DashboardScreens/MarketingHead/MProfile/MProfile"))
const FProfile = React.lazy(()=>import("./Pages/DashboardScreens/FinanceHead/FProfile/FProfile"))
const CProfile = React.lazy(()=>import("./Pages/DashboardScreens/ClinicalTeam/CDashboard/CProfile"))



const Help = React.lazy(()=>import("./Pages/DashboardScreens/SalesHead/HelpSupport/help"))

const NotificationMarketing = React.lazy(()=>import("./Pages/DashboardScreens/NotificationHead/NotificationMarketing"))
const NotificationClinical = React.lazy(()=>import("./Pages/DashboardScreens/NotificationHead/NotificationClinical"))
const NotificationSales = React.lazy(()=>import("./Pages/DashboardScreens/NotificationHead/NotificationSales"))
const NotificationFinance = React.lazy(()=>import("./Pages/DashboardScreens/NotificationHead/NotificationFinance"))

const Notification = React.lazy(()=>import("./Pages/DashboardScreens/Notification/Notification"))

function App() {
  return (
    <div className="App">
      <React.Fragment>
      <HashRouter>
      <React.Suspense fallback={<Loader/>}>
      <Notification/>
        <Routes>
          <Route path='/' index element= {<Login/>}/>
          <Route path='/SignUp' element={<SignUp/>}/>
          <Route path='/OTPVerfication' element={<OTPVerifIcation/>}/>
          <Route element={<DashboardLayout/>}>
            <Route path='/Analytics' element={<Analytics/>}/>
            <Route path='/Sales' element={<Sales/>}/>
            <Route path='/SInventory' element={<SInventory/>}/>
            <Route path='/Scheme' element={<Scheme/>}/>
            <Route path='/Conversations' element={<Conversations/>}/>


            {/* Clinical Head */}
            <Route path='/MyDashboard' element={<MyDashboard/>}/>
            <Route path='/HelpSupport' element={<HelpSupport/>}/>

            {/* MarketingHead */}
            <Route path='/MarketingAnalytics' element={<MarketingAnalytics/>}/>
            <Route path='/KPIManagement' element={<KPIManagement/>}/>
            <Route path='/Event' element={<Event/>}/>

            {/* Finance Head */}
            <Route path='/FAnalytics' element={<FAnalytics/>}/>
            <Route path='/FinanceManagement' element={<FinanceManagement/>}/>
            <Route path='/InventoryManagement' element={<InventoryManagement/>}/>
            <Route path='/PurchaseOrder' element={<PurchaseOrder/>}/>

            <Route path='/Profile' element={<Profile/>}/>
            <Route path='/MProfile' element={<MProfile/>}/>
            <Route path='/FProfile' element={<FProfile/>}/>
            <Route path='/CProfile' element={<CProfile/>}/>

            <Route path='/Help' element={<Help/>}/>
            <Route path='/NotificationMarketing' element={<NotificationMarketing/>}/>
            <Route path='/NotificationClinical' element={<NotificationClinical/>}/>
            <Route path='/NotificationSales' element={<NotificationSales/>}/>
            <Route path='/NotificationFinance' element={<NotificationFinance/>}/>


          </Route>
        </Routes>
        </React.Suspense>
      </HashRouter>
      </React.Fragment>
    </div>
  );
}

export default App;
